{
  "enum": {
    "ExcRouteV1FailoverBehavior": {
      "NEXT_DESTINATION": "Next Destination",
      "QUEUE": "Queue",
      "REJECT": "Reject",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1FixMessageStatus": {
      "RECORDED": "Recorded",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1FixOrderStatus": {
      "ACTIVE": "Active",
      "ACTIVE_C": "Active C",
      "CANCELLED": "Cancelled",
      "DONE": "Done",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1FixSessionStatus": {
      "CONNECTING": "Connecting",
      "DISCONNECTED": "Disconnected",
      "LOGGED_ON": "Logged On",
      "STOPPED": "Stopped",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1MessageDirection": {
      "INBOUND": "Inbound",
      "OUTBOUND": "Outbound",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1RejectCode": {
      "ADVANCED_FUNCTIONALITY_NOT_SUPPORTED": "Advanced Functionality Not Supported",
      "BAD_RESERVE_VALUE": "Bad Reserve Value",
      "HALTED": "Halted",
      "INTERNAL_NASDAQ_ERROR": "Internal Nasdaq Error",
      "INVALID_FIRM": "Invalid Firm",
      "INVALID_MIN_QTY": "Invalid Min Qty",
      "INVALID_ORDER_QTY": "Invalid Order Qty",
      "INVALID_ORDER_TYPE": "Invalid Order Type",
      "INVALID_PEG_TYPE": "Invalid Peg Type",
      "INVALID_PRICE": "Invalid Price",
      "INVALID_SIDE": "Invalid Side",
      "INVALID_STOCK": "Invalid Stock",
      "LOCATE_REQD_NOT_SET_N": "Locate Reqd Not Set N",
      "MIDPOINT_PEG_CROSSED_MARKET": "Midpoint Peg Crossed Market",
      "ORDER_SIZE_TOO_LARGE": "Order Size Too Large",
      "PEGGING_NOT_ALLOWED": "Pegging Not Allowed",
      "PORT_IN_TEST_MODE": "Port in Test Mode",
      "QUOTE_NOT_AVAILABLE_FOR_PEGGED": "Quote Not Available for Pegged",
      "RASH_NOT_OPEN": "Rash Not Open",
      "RESENT_ORDER_REJECTED": "Resent Order Rejected",
      "RISK_DUPLICATE_MESSAGE_RATE_EXCEEDED": "Risk Duplicate Message Rate Exceeded",
      "RISK_EXCEEDS_ADV_LIMIT": "Risk Exceeds Adv Limit",
      "RISK_EXECUTED_EXPOSURE_EXCEEDED": "Risk Executed Exposure Exceeded",
      "RISK_FAT_FINGER": "Risk Fat Finger",
      "RISK_LOCATE_REQUIRED": "Risk Locate Required",
      "RISK_MARKET_IMPACT": "Risk Market Impact",
      "RISK_MAX_NOTIONAL_EXCEEDED": "Risk Max Notional Exceeded",
      "RISK_MAX_SHARES_EXCEEDED": "Risk Max Shares Exceeded",
      "RISK_NOTIONAL_EXPOSURE_EXCEEDED": "Risk Notional Exposure Exceeded",
      "RISK_OPEN_EXPOSURE_EXCEEDED": "Risk Open Exposure Exceeded",
      "RISK_ORDER_TYPE_RESTRICTED": "Risk Order Type Restricted",
      "RISK_PORT_MESSAGE_RATE_EXCEEDED": "Risk Port Message Rate Exceeded",
      "RISK_RESTRICTED_STOCK": "Risk Restricted Stock",
      "RISK_SHORT_SELL_RESTRICTED": "Risk Short Sell Restricted",
      "RISK_SYMBOL_MESSAGE_RATE_EXCEEDED": "Risk Symbol Message Rate Exceeded",
      "ROUTING_DESTINATION_DOWN": "Routing Destination Down",
      "ROUTING_DESTINATION_NOT_SUPPORTED": "Routing Destination Not Supported",
      "ROUTING_NOT_ENABLED": "Routing Not Enabled",
      "UNKNOWN_ERROR": "Unknown Error",
      "UNSPECIFIED": "Unspecified",
      "UNSUPPORTED_ORDER_ATTRIBUTE": "Unsupported Order Attribute"
    },
    "ExcRouteV1RoutingRuleStatus": {
      "ACTIVE": "Active",
      "DISABLED": "Disabled",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1SequenceUpdateReason": {
      "BUMP": "Bump",
      "GAP_FILL": "Gap Fill",
      "MANUAL_SET": "Manual Set",
      "RESYNC": "Resync",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1TradingHours": {
      "EXTENDED": "Extended",
      "REGULAR": "Regular",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcRouteV1VenueType": {
      "JANESTREET": "Jane Street",
      "NASDAQ": "Nasdaq",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcRouteV1FixMessageQueryServiceFixMessageListFilterableFields": {
      "fixMessageId": "FIX Message",
      "fixOrderId": "FIX Order",
      "status": "Status"
    },
    "ExcRouteV1FixOrderQueryServiceFixOrderListFilterableFields": {
      "clOrderId": "Cl Order",
      "data": {
        "spec": {
          "side": "Side"
        }
      },
      "status": "Status"
    },
    "ExcRouteV1FixSessionQueryServiceFixSessionListFilterableFields": {
      "sessionId": "Session",
      "status": "Status"
    },
    "ExcRouteV1RoutingRuleQueryServiceRoutingRuleListFilterableFields": {
      "ruleId": "Rule ID",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcRouteV1FixMessageEventType": {
      "recorded": "Recorded"
    },
    "ExcRouteV1FixOrderEventType": {
      "accepted": "Accepted",
      "cancelRejected": "Cancel Rejected",
      "canceled": "Canceled",
      "created": "Created",
      "done": "Done",
      "fill": "Fill",
      "rejected": "Rejected",
      "requestCancel": "Request Cancel"
    },
    "ExcRouteV1FixSessionEventType": {
      "configUpdated": "Config Updated",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "initiatorStarted": "Initiator Started",
      "initiatorStopped": "Initiator Stopped",
      "registered": "Registered",
      "resendRequested": "Resend Requested",
      "sequenceNumbersReset": "Sequence Numbers Reset",
      "sequenceNumbersUpdated": "Sequence Numbers Updated"
    },
    "ExcRouteV1ParentOrder": {
      "customer": "Customer",
      "firm": "Firm"
    },
    "ExcRouteV1RoutingFilterType": {
      "matchAll": "Match All",
      "priceFilter": "Price Filter",
      "symbolFilter": "Symbol Filter",
      "timeWindow": "Time Window"
    },
    "ExcRouteV1RoutingRuleEventType": {
      "created": "Created",
      "disabled": "Disabled",
      "enabled": "Enabled",
      "updated": "Updated"
    }
  },
  "sortEnum": {
    "ExcRouteV1FixMessageQueryServiceFixMessageListSortableFields": {
      "data": {
        "sent": "Sent"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcRouteV1FixOrderQueryServiceFixOrderListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcRouteV1FixSessionQueryServiceFixSessionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcRouteV1RoutingRuleQueryServiceRoutingRuleListSortableFields": {
      "data": {
        "priority": "Priority"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}